export function loginTokenIsInHash() {
  return (
    window.location.hash.match(/auth/) && window.location.hash.match(/refresh/)
  );
}
